import React from 'react';

import ClickDialogCloseBtn from './controls/close';
import ClickDialogSubTitle from './controls/sub-title';

export interface IProps {
  className?: string;
  closable?: boolean;
  subTitle?: React.ReactNode;
  title?: React.ReactNode;

  onClose?: () => void;
}

const ClickDialogHeader: React.FC<IProps> = React.memo(
  ({ className: pClassName, closable, subTitle, title, onClose }) => {
    const className = React.useMemo<string>(() => {
      return ['flex justify-between shrink-0'].addNotEmpty(pClassName).toClassNames();
    }, [pClassName]);

    return (
      <div className={className}>
        <div className="flex flex-col">
          <h3 className="text-lg font-semibold text-gray-600">{title}</h3>
          {!!subTitle && <ClickDialogSubTitle>{subTitle}</ClickDialogSubTitle>}
        </div>
        {closable && <ClickDialogCloseBtn onClose={onClose} />}
      </div>
    );
  }
);

ClickDialogHeader.displayName = 'ClickDialogHeader';

export default ClickDialogHeader;
